<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'layout-wrapper-overlay-sidebar': isOverlay(),
                 'layout-wrapper-slim-sidebar': isSlim(),
                 'layout-wrapper-overlay-sidebar-active': overlayMenuActive,
                 'layout-wrapper-sidebar-inactive': staticMenuDesktopInactive,
                 'layout-wrapper-sidebar-mobile-active': staticMenuMobileActive, 'p-ripple-disabled': !app.ripple, 'p-input-filled': app.inputStyle === 'filled'}">
    <app-topbar></app-topbar>

    <div class="layout-sidebar" (click)="onMenuClick($event)">
        <div class="sidebar-scroll-content">
            <app-inline-profile *ngIf="app.profileMode=='inline' && !isHorizontal()"></app-inline-profile>
            <app-menu></app-menu>
            <a *ngIf="false" [routerLink]="'/subscription'"><img src="assets/img/first-days-promo.jpg" style="max-width: 230px;" /></a>
        </div>
    </div>

    <app-rightpanel></app-rightpanel>

    <div class="layout-main">
        <app-breadcrumb></app-breadcrumb>

        <div class="layout-main-content">
            <router-outlet></router-outlet>
        </div>

        <app-footer></app-footer>
    </div>

    <p-toast position="bottom-center"></p-toast>
</div>

